


















import { defineComponent, computed, Ref, ref, onMounted, ComputedRef, } from "@vue/composition-api";

export default defineComponent({
    components: {
    },
    props: [
        'isVisible',
    ],
    setup(props, context) {
        const showModal = computed({
            get() {
                return props.isVisible;
            },
            set(newValue) {
                context.emit('onClose', newValue);            
            },
        });

        const closeModal = () => {
            context.emit('onClose');
        }

        return {
            showModal,
            closeModal,
        };
    },
});
